module.exports = __webpack_public_path__ + "img/metaplex-logo.45114b08.svg";